import Document from '@app/store/document/Document';
import DocumentStatus from '@app/store/document/Status';
import DocumentsStatus from '@app/store/documents/Status';

export default (document: Document, userEmail: string) => {
  switch (document.status) {
    case DocumentStatus.COMPLETED:
      return DocumentsStatus.COMPLETED;
    case DocumentStatus.ON_GOING: {
      // 사용자가 문서의 서명자중에 있는지 확인
      const user = document.participants.find(
        (participant) => participant.signingMethod.contactInfo === userEmail
      );
      if (user) {
        // 현재 서명할 서명자
        const currentSigningParticipant = document.participants
          .filter((participant) => participant.signingOrder === document.currentSigningOrder)
          // 순서없는 서명에서는 signingOrder가 같은 서명자가 여러명이라 contactInfo까지 비교해야 함
          .find((participant) => participant.signingMethod.contactInfo === userEmail);

        if (currentSigningParticipant) {
          // 현재 서명할 서명자 인지 확인
          if (currentSigningParticipant.signingMethod.contactInfo === userEmail) {
            return DocumentsStatus.NEED_SIGNING;
          }
          return DocumentsStatus.WAIT_FOR_SIGNING;
        }
      } else if (document.requester.email === userEmail) {
        // 사용자가 문서의 서명자는 아니지만 요청자일 경우
        return DocumentsStatus.WAIT_FOR_SIGNING;
      }
      return DocumentsStatus.ON_SIGNING;
    }
    case DocumentStatus.ON_PROCESSING:
      return DocumentsStatus.ON_PROCESSING;
    case DocumentStatus.PENDING: {
      if (document.pending?.pendingType === 'rejection') {
        return DocumentsStatus.REJECTED;
      }
      if (document.pending?.pendingType === 'signing_cancellation') {
        return DocumentsStatus.SIGNING_CANCELLED;
      }
      if (document.pending?.pendingType === 'request_cancellation') {
        return DocumentsStatus.REQUEST_CANCELLED;
      }
      throw new Error('invalid pending information');
    }
    case DocumentStatus.PROCESSING_FAILED:
      return DocumentsStatus.PROCESSING_FAILED;
    default:
      throw new Error('invalid status');
  }
};
